import React, {useEffect} from 'react';
import {Menu, MenuButton, MenuItem, MenuItems, Transition} from "@headlessui/react";
import {useQuery} from "@tanstack/react-query";
import corporationService from "../../services/web/corporation-service.js";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const HeaderTemplateMenuContent = ({open, close, selected, data, menuClassName, handleSelected, onOpenChange}) => {
    useEffect(() => {
        onOpenChange?.(open);
    }, [open, onOpenChange]);

    useEffect(() => {
        if (!open) return;

        const closeOtherDropdown = (event) => {
            if (event.detail !== 'header') close();
        };

        document.addEventListener('report-dropdown-open', closeOtherDropdown);

        return () => {
            document.removeEventListener('report-dropdown-open', closeOtherDropdown);
        };
    }, [close, open]);

    return (
        <>
            <MenuButton type="button" className={"flex justify-center cursor-pointer h-[32px] items-center gap-1 focus:ring-2 focus:outline-none font-bold rounded-md shadow text-[13px] px-4 py-2 text-white bg-[#063A6C] hover:bg-blue-800 focus:ring-blue-300"}>
                Alterar cabeçalho
            </MenuButton>
            <Transition
                enter="transition ease-out duration-75"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
            >
                <MenuItems
                    modal={false}
                    className={`${menuClassName} absolute top-[42px] right-2 mt-1 overflow-hidden w-36 origin-top-right rounded-md shadow border text-[13px] bg-white focus:outline-none z-[9999] text-gray-700 flex flex-col border-[#bdbdbd]`}
                >
                    {data?.map(template => (
                        <MenuItem key={template.name + "-" + template.id}>
                            <button
                                className={["w-full text-[13px] py-2 px-4 cursor-pointer text-left text-gray-700 block text-sm hover:bg-[#063A6C] hover:text-white", (selected?.id === template.id ? "bg-[#063A6C] text-white" : null)].join(" ")}
                                onClick={() => handleSelected(template)}
                            >
                                {template.name}
                            </button>
                        </MenuItem>
                    ))}
                </MenuItems>
            </Transition>
        </>
    );
};

const HeaderTemplateButton = ({selected, setSelected, menuClassName = '', onOpenChange}) => {
    const {data, isSuccess} = useQuery({
        queryFn: () => corporationService.headerTemplates(),
        queryKey: ["headerTemplates"]
    });

    useEffect(() => {
        if (isSuccess) {
            handleSelected(data[0])
        }
    }, [isSuccess]);

    const handleSelected = (template) => {
        template.addressFormated = [
            template.address,
            template.number && (template.address ? ", " : "") + template.number,
            template.neighborhood && (template.address || template.number ? ", " : "") + template.neighborhood,
            template.city && (template.address || template.number || template.neighborhood ? ", " : "") + template.city,
        ].filter(Boolean).join('');

        template.imagePath = template?.image_id ? `${API_KEEPER}/ged/attach/${template?.image_id}` : `${API_URL}/corporation/entity/image`

        setSelected(template);
    }

    return (
        <Menu as="div" className="flex items-center text-white h-[32px]">
            {({open, close}) => (
                <HeaderTemplateMenuContent
                    open={open}
                    close={close}
                    selected={selected}
                    data={data}
                    menuClassName={menuClassName}
                    handleSelected={handleSelected}
                    onOpenChange={onOpenChange}
                />
            )}
        </Menu>
    );
};

export default HeaderTemplateButton;